import React from 'react'
import { useTranslation } from 'react-i18next'

const Title = () => {
  const { t } = useTranslation()

  return <div>{t('total_posts_with_scores')}</div>
}

export default Title
